import React, { useState, useEffect, useCallback, useRef } from 'react';
import { axios } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export function RehberDevamsizlikPage() {
  const [loading, setLoading] = useState(false);
  const [ogrenciListesi, setOgrenciListesi] = useState([]);
  const [gununDersleri, setGununDersleri] = useState([]);
  const [siniflar, setSiniflar] = useState([]);
  const [dersListesi, setDersListesi] = useState([]);

  const [filtre, setFiltre] = useState({
    sinif_id: '',
    ders_id: '',
    tarih: new Date().toISOString().slice(0, 10)
  });

  const DURUM = {
    mevcut: { icon: '✅', label: 'Var', color: '#10B981' },
    devamsiz: { icon: '❌', label: 'Yok', color: '#EF4444' },
    gec: { icon: '⏰', label: 'Geç', color: '#F59E0B' },
    yok: { icon: '—', label: 'Girilmedi', color: '#CBD5E1' }
  };

  useEffect(() => {
    Promise.all([
      axios.get('/siniflar'),
      axios.get('/dersler')
    ]).then(([sRes, dRes]) => {
      setSiniflar(sRes.data.data || []);
      setDersListesi(dRes.data.data || []);
    }).catch(() => toast.error("Tanımlamalar yüklenemedi"));
  }, []);

  const loadPivotVeri = useCallback(async () => {
    if (!filtre.sinif_id) {
      toast.error("Lütfen bir sınıf seçin");
      return;
    }

    setLoading(true);
    try {
      const { data } = await axios.get(`/yoklama/rehber/detayli?sinif_id=${filtre.sinif_id}&tarih=${filtre.tarih}`);

      if (data.success) {
        setOgrenciListesi(data.data || []);

        if (filtre.ders_id && data.dersler) {
          setGununDersleri(data.dersler.filter(d => d.ders_id == filtre.ders_id));
        } else {
          setGununDersleri(data.dersler || []);
        }
      }
    } catch (err) {
      toast.error("Veriler çekilemedi. API rotasını kontrol edin.");
    } finally {
      setLoading(false);
    }
  }, [filtre]);

  const handleExcelExport = () => {
    if (ogrenciListesi.length === 0) return toast.error("Aktarılacak veri yok");

    const exportData = ogrenciListesi.map(ogr => {
      const obj = {
        "Öğrenci No": ogr.ogrenci_no,
        "Ad Soyad": `${ogr.ad} ${ogr.soyad}`
      };
      gununDersleri.forEach(d => {
        const dKey = `${d.baslangic_saati.slice(0, 5)} ${d.ders_adi}`;
        const durumKey = ogr.yoklamalar?.[d.id] || 'yok';
        obj[dKey] = DURUM[durumKey].label;
      });
      return obj;
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Devamsızlık");
    XLSX.writeFile(wb, `Yoklama_${filtre.tarih}_Sinif_${filtre.sinif_id}.xlsx`);
    toast.success("Excel indirildi!");
  };

  const handlePdfExport = () => {
    if (ogrenciListesi.length === 0) return toast.error("Aktarılacak veri yok");

    const doc = new jsPDF('l', 'mm', 'a4');
    doc.setFont("helvetica", "bold");
    doc.text(`${filtre.tarih} Tarihli Yoklama Çizelgesi`, 14, 15);

    const headers = [["Öğrenci", ...gununDersleri.map(d => `${d.baslangic_saati.slice(0, 5)}\n${d.ders_adi}`), "Toplam Yok"]];

    const body = ogrenciListesi.map(ogr => [
      `${ogr.ad} ${ogr.soyad}`,
      ...gununDersleri.map(d => {
        const dKey = ogr.yoklamalar?.[d.id] || 'yok';
        return dKey === 'mevcut' ? 'VAR' : dKey === 'devamsiz' ? 'YOK' : dKey === 'gec' ? 'GEC' : '-';
      }),
      Object.values(ogr.yoklamalar || {}).filter(v => v === 'devamsiz').length
    ]);

    autoTable(doc, {
      head: headers,
      body: body,
      startY: 20,
      theme: 'grid',
      styles: { fontSize: 8, halign: 'center' },
      headStyles: { fillColor: [220, 38, 38], textColor: 255 },
      columnStyles: { 0: { halign: 'left', fontStyle: 'bold', cellWidth: 40 } },
      didParseCell: (data) => {
        if (data.cell.raw === 'YOK') data.cell.styles.textColor = [239, 68, 68];
        if (data.cell.raw === 'VAR') data.cell.styles.textColor = [16, 185, 129];
      }
    });

    doc.save(`Yoklama_Raporu_${filtre.tarih}.pdf`);
  };

  return (
    <div className="page-container" style={{ display: 'flex', flexDirection: 'column', gap: 24, padding: '10px' }}>
      {/* Mobil Uyum İçin Dinamik CSS */}
      <style>{`
        @media (max-width: 768px) {
          .section-header { flex-direction: column; align-items: flex-start !important; gap: 15px; }
          .section-header div:last-child { width: 100%; justify-content: space-between; }
          .section-header button { flex: 1; font-size: 0.8rem; }
          
          /* Tabloyu kart yapısına çevir */
          .mobile-responsive-table thead { display: none; }
          .mobile-responsive-table, .mobile-responsive-table tbody, .mobile-responsive-table tr, .mobile-responsive-table td { 
            display: block; 
            width: 100%; 
          }
          .mobile-responsive-table tr { 
            margin-bottom: 20px; 
            border: 1px solid var(--border); 
            border-radius: 12px; 
            background: var(--bg-card);
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
            overflow: hidden;
          }
          .mobile-responsive-table td { 
            text-align: right !important; 
            padding: 12px 15px !important; 
            border-bottom: 1px solid var(--border-subtle); 
            position: relative;
            min-height: 45px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .mobile-responsive-table td:last-child { border-bottom: none; background: #fff5f5; }
          .mobile-responsive-table td::before {
            content: attr(data-label);
            font-weight: 700;
            text-align: left;
            font-size: 0.8rem;
            color: var(--text-muted);
          }
          /* Sticky özelliği mobilde bozulmaması için sıfırla */
          .mobile-responsive-table td:first-child { 
            position: relative !important; 
            background: var(--accent-dim) !important; 
            color: var(--accent) !important; 
            text-align: left !important;
            justify-content: flex-start;
          }
        }
      `}</style>

      <div className="section-header animate-fadeInUp" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.6rem', fontWeight: 800 }}>📊 Yoklama Takibi</h2>
          <div className="section-subtitle">Öğrenci bazlı detaylı ders katılım dökümü</div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn btn-outline" onClick={handlePdfExport}>📄 PDF</button>
          <button className="btn btn-success" onClick={handleExcelExport}>📥 Excel</button>
        </div>
      </div>

      <div className="card animate-fadeInUp stagger-1" style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 15, alignItems: 'end', padding: '20px'
      }}>
        <div className="form-group">
          <label className="form-label">📅 Tarih</label>
          <input type="date" className="form-input" value={filtre.tarih} onChange={e => setFiltre({ ...filtre, tarih: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">🏫 Sınıf Seçimi</label>
          <select className="form-select" value={filtre.sinif_id} onChange={e => setFiltre({ ...filtre, sinif_id: e.target.value })}>
            <option value="">Seçiniz...</option>
            {siniflar.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">📚 Ders Filtresi</label>
          <select className="form-select" value={filtre.ders_id} onChange={e => setFiltre({ ...filtre, ders_id: e.target.value })}>
            <option value="">Tüm Günün Dersleri</option>
            {dersListesi.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
          </select>
        </div>
        <button className="btn btn-primary" onClick={loadPivotVeri} style={{ height: 42 }}>🔍 Sorgula</button>
      </div>

      <div className="card animate-fadeInUp stagger-2" style={{ padding: 0, overflow: 'hidden', border: 'none' }}>
        <div className="table-wrapper">
          <table className="table mobile-responsive-table">
            <thead>
              <tr style={{ background: 'var(--bg-elevated)' }}>
                <th style={{ minWidth: 220, position: 'sticky', left: 0, zIndex: 10, background: 'var(--bg-elevated)' }}>Öğrenci Bilgisi</th>
                {gununDersleri.map(d => (
                  <th key={d.id} style={{ textAlign: 'center', minWidth: 100 }}>
                    <div style={{ fontSize: '0.65rem', color: 'var(--accent)', fontWeight: 800 }}>{d.baslangic_saati.slice(0, 5)}</div>
                    <div style={{ fontSize: '0.75rem' }}>{d.ders_adi}</div>
                  </th>
                ))}
                <th style={{ textAlign: 'center', minWidth: 80 }}>Yok Sayısı</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="30" style={{ textAlign: 'center', padding: 60 }}><div className="spinner" /></td></tr>
              ) : ogrenciListesi.length === 0 ? (
                <tr><td colSpan="30" className="empty-state" style={{ textAlign: 'center', padding: '40px' }}>Sorgulama yapmak için sınıf seçiniz.</td></tr>
              ) : ogrenciListesi.map((ogr) => (
                <tr key={ogr.id} className="hover-scale">
                  <td style={{ fontWeight: 700, position: 'sticky', left: 0, background: 'var(--bg-card)', zIndex: 5, borderRight: '1px solid var(--border)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div className="avatar avatar-xs" style={{ background: 'var(--accent-dim)', color: 'var(--accent)', fontWeight: 800 }}>{ogr.ad?.[0]}</div>
                      <div>
                        <div style={{ fontSize: '0.85rem' }}>{ogr.ad} {ogr.soyad}</div>
                        <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>No: {ogr.ogrenci_no}</div>
                      </div>
                    </div>
                  </td>
                  {gununDersleri.map(d => {
                    const status = ogr.yoklamalar?.[d.id] || 'yok';
                    return (
                      <td key={d.id} data-label={`${d.baslangic_saati.slice(0, 5)} - ${d.ders_adi}`} style={{ textAlign: 'center' }}>
                        <span style={{ fontSize: '1.2rem', color: DURUM[status].color }}>{DURUM[status].icon}</span>
                        <span className="mobile-only-label" style={{ display: 'none' }}>{DURUM[status].label}</span>
                      </td>
                    );
                  })}
                  <td data-label="Toplam Yok" style={{ textAlign: 'center', fontWeight: 800, color: '#EF4444' }}>
                    {Object.values(ogr.yoklamalar || {}).filter(v => v === 'devamsiz').length}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
// ── Görüşme Günlüğü ───────────────────────────────────────────
export function GorusmelerPage() {
  const [gorusmeler, setGorusmeler] = useState([]);
  const [ogrenciler, setOgrenciler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    ogrenci_id: '', tarih: new Date().toISOString().slice(0, 10),
    konu: '', notlar: '', sonraki_adimlar: '', durum: 'planli',
  });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [gRes, oRes] = await Promise.all([
        axios.get('/rehberlik/gorusmeler'),
        axios.get('/ogrenciler?limit=200'),
      ]);
      if (gRes.data.success) setGorusmeler(gRes.data.data);
      if (oRes.data.success) setOgrenciler(oRes.data.data);
    } catch { toast.error('Yükleme hatası'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleCreate = async () => {
    if (!form.ogrenci_id || !form.konu) { toast.error('Öğrenci ve konu zorunlu'); return; }
    try {
      await axios.post('/rehberlik/gorusmeler', form);
      toast.success('Görüşme kaydedildi!');
      setShowModal(false);
      setForm({ ogrenci_id: '', tarih: new Date().toISOString().slice(0, 10), konu: '', notlar: '', sonraki_adimlar: '', durum: 'planli' });
      load();
    } catch { toast.error('Kayıt hatası'); }
  };

  const DURUM_COLORS = { planli: '#3B82F6', tamamlandi: '#10B981', iptal: '#EF4444' };
  const DURUM_LABELS = { planli: '📅 Planlı', tamamlandi: '✅ Tamamlandı', iptal: '❌ İptal' };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="section-header animate-fadeInUp">
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>💬 Görüşme Günlüğü</h2>
          <div className="section-subtitle">{gorusmeler.length} görüşme kaydı</div>
        </div>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Yeni Görüşme</button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }} className="animate-fadeInUp stagger-1">
        {loading ? (
          Array(4).fill(0).map((_, i) => (
            <div key={i} className="skeleton" style={{ height: 100, borderRadius: 16 }} />
          ))
        ) : gorusmeler.length === 0 ? (
          <div className="card">
            <div className="empty-state">
              <div style={{ fontSize: '2.5rem' }}>💬</div>
              <h3>Görüşme kaydı yok</h3>
              <p>Yeni görüşme ekleyerek başlayın.</p>
            </div>
          </div>
        ) : gorusmeler.map((g, i) => (
          <div key={i} className="card" style={{ borderLeft: `3px solid ${DURUM_COLORS[g.durum] || '#94A3B8'}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div className="avatar avatar-sm" style={{ background: 'rgba(139,92,246,0.15)', color: '#8B5CF6' }}>
                  {g.ogrenci_ad?.[0]}{g.ogrenci_soyad?.[0]}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '0.9rem' }}>{g.ogrenci_ad} {g.ogrenci_soyad}</div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
                    {new Date(g.tarih).toLocaleDateString('tr-TR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                  </div>
                </div>
              </div>
              <span style={{
                background: DURUM_COLORS[g.durum] + '20',
                color: DURUM_COLORS[g.durum],
                padding: '3px 10px', borderRadius: 99,
                fontSize: '0.75rem', fontWeight: 600,
              }}>
                {DURUM_LABELS[g.durum]}
              </span>
            </div>
            <div style={{ marginBottom: 8 }}>
              <span style={{ fontSize: '0.82rem', fontWeight: 600, color: 'var(--text-primary)' }}>Konu: </span>
              <span style={{ fontSize: '0.82rem', color: 'var(--text-secondary)' }}>{g.konu}</span>
            </div>
            {g.notlar && (
              <div style={{ padding: '8px 12px', background: 'var(--bg-elevated)', borderRadius: 8, fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: 8 }}>
                📝 {g.notlar}
              </div>
            )}
            {g.sonraki_adimlar && (
              <div style={{ padding: '8px 12px', background: 'rgba(16,185,129,0.06)', borderRadius: 8, border: '1px solid rgba(16,185,129,0.15)', fontSize: '0.8rem', color: '#10B981' }}>
                → Sonraki adımlar: {g.sonraki_adimlar}
              </div>
            )}
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-backdrop" onClick={() => setShowModal(false)}>
          <div className="modal" style={{ maxWidth: 580 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">💬 Yeni Görüşme Ekle</div>
              <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Öğrenci *</label>
                  <select className="form-select" value={form.ogrenci_id} onChange={e => setForm({ ...form, ogrenci_id: e.target.value })}>
                    <option value="">Seçin</option>
                    {ogrenciler.map(o => <option key={o.id} value={o.id}>{o.ad} {o.soyad}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Tarih</label>
                  <input className="form-input" type="date" value={form.tarih} onChange={e => setForm({ ...form, tarih: e.target.value })} />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Konu *</label>
                <input className="form-input" placeholder="Üniversite seçimi, motivasyon..." value={form.konu} onChange={e => setForm({ ...form, konu: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">Görüşme Notları</label>
                <textarea className="form-textarea" placeholder="Görüşme detayları..." value={form.notlar} onChange={e => setForm({ ...form, notlar: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">Sonraki Adımlar</label>
                <textarea className="form-textarea" placeholder="Öğrenciye verilen görevler, bir sonraki görüşme..." value={form.sonraki_adimlar} onChange={e => setForm({ ...form, sonraki_adimlar: e.target.value })} style={{ minHeight: 70 }} />
              </div>
              <div className="form-group">
                <label className="form-label">Durum</label>
                <select className="form-select" value={form.durum} onChange={e => setForm({ ...form, durum: e.target.value })}>
                  <option value="planli">Planlı</option>
                  <option value="tamamlandi">Tamamlandı</option>
                  <option value="iptal">İptal</option>
                </select>
              </div>
              <div style={{ display: 'flex', gap: 10 }}>
                <button className="btn btn-primary" style={{ flex: 1, justifyContent: 'center' }} onClick={handleCreate}>✓ Kaydet</button>
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Çalışma Programı ─────────────────────────────────────────
const PROGRAM_GUNLERI = [
  { key: 'Pazartesi', label: 'Pazartesi' },
  { key: 'Sali', label: 'Salı' },
  { key: 'Carsamba', label: 'Çarşamba' },
  { key: 'Persembe', label: 'Perşembe' },
  { key: 'Cuma', label: 'Cuma' },
  { key: 'Cumartesi', label: 'Cumartesi' },
  { key: 'Pazar', label: 'Pazar' },
];

const PROGRAM_TURLERI = [
  { value: 'haftalik', label: 'Haftalık Program Hazırla', helper: '7 gün boyunca oturum bazlı plan oluştur.' },
  { value: 'gunluk', label: 'Günlük Program Hazırla', helper: 'Tek bir tarih için oturum listesi hazırlayın.' },
];

const PROGRAM_OTURUMLARI = Array.from({ length: 6 }, (_, index) => ({
  slot_no: index + 1,
  slot_etiketi: `${index + 1}. Oturum`,
}));

const EMPTY_PROGRAM_CELL = { ders_id: '', konu: '', soru_sayisi: '', aciklama: '', rehber_notu: '' };

function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

function addDaysToIso(dateStr, days) {
  if (!dateStr) return '';
  const date = new Date(`${dateStr}T12:00:00`);
  if (Number.isNaN(date.getTime())) return '';
  date.setDate(date.getDate() + days);
  return date.toISOString().slice(0, 10);
}

function formatDateLabel(dateStr) {
  const normalized = normalizeDateInput(dateStr);
  if (!normalized) return '—';
  const date = new Date(`${normalized}T12:00:00`);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' });
}

function getProgramDayFromDate(dateStr) {
  const normalized = normalizeDateInput(dateStr);
  if (!normalized) return PROGRAM_GUNLERI[0];
  const date = new Date(`${normalized}T12:00:00`);
  if (Number.isNaN(date.getTime())) return PROGRAM_GUNLERI[0];
  const dayIndex = (date.getDay() + 6) % 7;
  return PROGRAM_GUNLERI[dayIndex];
}

function getCellKey(gun, slotNo) {
  return `${gun}__${slotNo}`;
}

function normalizeDateInput(value) {
  if (!value) return '';
  const toLocalInput = (dateObj) => {
    if (!dateObj || Number.isNaN(dateObj.getTime())) return '';
    const yyyy = dateObj.getFullYear();
    const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
    const dd = String(dateObj.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };
  if (typeof value !== 'string') {
    return toLocalInput(new Date(value));
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  if (value.includes('T')) {
    return toLocalInput(new Date(value));
  }
  return toLocalInput(new Date(value));
}

function normalizeCell(cell = {}) {
  return {
    ders_id: cell.ders_id ?? '',
    konu: cell.konu ?? '',
    soru_sayisi: cell.soru_sayisi ?? '',
    aciklama: cell.aciklama ?? '',
    rehber_notu: cell.rehber_notu ?? '',
  };
}

function isCellMeaningful(cell = {}) {
  return Boolean(cell.ders_id || cell.konu || cell.soru_sayisi || cell.aciklama || cell.rehber_notu);
}

function buildAciklama(aciklama, rehberNotu) {
  const parts = [];
  if (aciklama?.trim()) parts.push(aciklama.trim());
  if (rehberNotu?.trim()) parts.push(`Rehber notu: ${rehberNotu.trim()}`);
  return parts.join('\n');
}

export function CalismaPrograPage() {
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 900 : false);
  const [mobilGun, setMobilGun] = useState(PROGRAM_GUNLERI[0].key);
  const initialDate = todayIso();
  const [programlar, setProgramlar] = useState([]);
  const [ogrenciler, setOgrenciler] = useState([]);
  const [siniflar, setSiniflar] = useState([]);
  const [dersler, setDersler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [detayLoading, setDetayLoading] = useState(false);
  const [seciliProgramDetay, setSeciliProgramDetay] = useState(null);
  const [editingProgramId, setEditingProgramId] = useState(null);
  const [ogrenciArama, setOgrenciArama] = useState('');
  const [ogrenciSinifFilter, setOgrenciSinifFilter] = useState('');
  const [form, setForm] = useState({
    ogrenci_id: '',
    program_turu: '',
    baslangic_tarihi: initialDate,
    bitis_tarihi: addDaysToIso(initialDate, 6),
    baslik: '',
    hedef: '',
  });
  const [gridData, setGridData] = useState({});
  const [activeCellKey, setActiveCellKey] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [pRes, oRes, dRes, sRes] = await Promise.all([
        axios.get('/rehberlik/programlar'),
        axios.get('/ogrenciler?limit=1000'),
        axios.get('/dersler'),
        axios.get('/siniflar'),
      ]);
      if (pRes.data.success) setProgramlar(pRes.data.data || []);
      if (oRes.data.success) setOgrenciler(oRes.data.data || []);
      if (dRes.data.success) setDersler(dRes.data.data || []);
      if (sRes.data.success) setSiniflar(sRes.data.data || []);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Program verileri yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (!form.program_turu || !form.baslangic_tarihi) return;
    setForm(prev => {
      if (prev.program_turu === 'haftalik') {
        const nextBitis = addDaysToIso(prev.baslangic_tarihi, 6);
        if (prev.bitis_tarihi === nextBitis) return prev;
        return { ...prev, bitis_tarihi: nextBitis };
      }
      if (prev.bitis_tarihi === prev.baslangic_tarihi) return prev;
      return { ...prev, bitis_tarihi: prev.baslangic_tarihi };
    });
  }, [form.program_turu, form.baslangic_tarihi]);

  const seciliOgrenci = ogrenciler.find(o => String(o.id) === String(form.ogrenci_id));
  const ogrenciSearch = ogrenciArama.trim().toLowerCase();
  const selectedSinifName = siniflar.find(s => String(s.id) === String(ogrenciSinifFilter))?.ad?.toLowerCase() || '';
  const filteredOgrenciler = ogrenciler.filter(ogr => {
    if (ogrenciSinifFilter) {
      const sinifMatch =
        String(ogr.sinif_id || '') === String(ogrenciSinifFilter) ||
        String(ogr.sinif?.id || '') === String(ogrenciSinifFilter);
      if (!sinifMatch && selectedSinifName) {
        const ogrSinifName = String(
          ogr.sinif_ad ||
          ogr.sinif_adi ||
          ogr.sinif ||
          ogr.sinif?.ad ||
          ''
        ).toLowerCase();
        if (!ogrSinifName.includes(selectedSinifName)) return false;
      }
      if (!sinifMatch && !selectedSinifName) return false;
    }
    if (ogrenciSearch) {
      const adSoyad = `${ogr.ad || ''} ${ogr.soyad || ''}`.toLowerCase();
      const no = String(ogr.ogrenci_no || ogr.numara || '');
      if (!adSoyad.includes(ogrenciSearch) && !no.includes(ogrenciSearch)) return false;
    }
    return true;
  });

  const gorunenGunler = form.program_turu === 'haftalik'
    ? PROGRAM_GUNLERI
    : form.program_turu === 'gunluk'
      ? [getProgramDayFromDate(form.baslangic_tarihi)]
      : [];
  const aktifMobilGun = gorunenGunler.some(g => g.key === mobilGun) ? mobilGun : (gorunenGunler[0]?.key || PROGRAM_GUNLERI[0].key);
  const tabloGunler = isMobile && form.program_turu === 'haftalik'
    ? gorunenGunler.filter(g => g.key === aktifMobilGun)
    : gorunenGunler;

  useEffect(() => {
    if (!gorunenGunler.length) {
      setActiveCellKey(null);
      return;
    }
    const firstKey = getCellKey(gorunenGunler[0].key, PROGRAM_OTURUMLARI[0].slot_no);
    setActiveCellKey(prev => prev || firstKey);
  }, [form.program_turu, form.baslangic_tarihi]);

  const activeCellMeta = (() => {
    if (!activeCellKey) return null;
    const [gunKey, slotNoRaw] = activeCellKey.split('__');
    const day = gorunenGunler.find(item => item.key === gunKey) || PROGRAM_GUNLERI.find(item => item.key === gunKey);
    const slot = PROGRAM_OTURUMLARI.find(item => String(item.slot_no) === String(slotNoRaw));
    if (!day || !slot) return null;
    return { gunKey, gunLabel: day.label, slotNo: slot.slot_no, slotEtiketi: slot.slot_etiketi };
  })();

  const activeCell = activeCellMeta ? normalizeCell(gridData[activeCellKey]) : EMPTY_PROGRAM_CELL;

  const updateCellField = (field, value) => {
    if (!activeCellMeta) return;
    setGridData(prev => {
      const next = { ...prev };
      const current = normalizeCell(prev[activeCellKey]);
      const updated = { ...current, [field]: value };
      if (!isCellMeaningful(updated)) delete next[activeCellKey];
      else next[activeCellKey] = updated;
      return next;
    });
  };

  const clearActiveCell = () => {
    if (!activeCellMeta) return;
    setGridData(prev => {
      const next = { ...prev };
      delete next[activeCellKey];
      return next;
    });
  };

  const resetBuilder = () => {
    const nextDate = todayIso();
    setForm({
      ogrenci_id: '',
      program_turu: '',
      baslangic_tarihi: nextDate,
      bitis_tarihi: addDaysToIso(nextDate, 6),
      baslik: '',
      hedef: '',
    });
    setGridData({});
    setActiveCellKey(null);
    setEditingProgramId(null);
  };

  const parseAciklama = (raw = '') => {
    if (!raw) return { aciklama: '', rehber_notu: '' };
    const lines = String(raw).split('\n');
    let rehberNotu = '';
    const remaining = lines.filter(line => {
      if (/^rehber notu:/i.test(line.trim())) {
        rehberNotu = line.replace(/^rehber notu:/i, '').trim();
        return false;
      }
      return true;
    });
    return { aciklama: remaining.join('\n').trim(), rehber_notu: rehberNotu };
  };

  const mapDetaylarToGrid = (detaylar = []) => {
    const next = {};
    detaylar.forEach(detay => {
      const dayObj = detay.gun ? { key: detay.gun } : getProgramDayFromDate(detay.tarih);
      const gunKey = dayObj?.key || PROGRAM_GUNLERI[0].key;
      const slotNo = detay.slot_no || 1;
      const key = getCellKey(gunKey, slotNo);
      const { aciklama, rehber_notu } = parseAciklama(detay.aciklama || '');
      next[key] = {
        ders_id: detay.ders_id || '',
        konu: detay.konu || '',
        soru_sayisi: detay.soru_sayisi || '',
        aciklama,
        rehber_notu,
      };
    });
    return next;
  };

  const olusturulanDetaylar = Object.entries(gridData)
    .map(([key, cell]) => {
      const [gun, slotNoRaw] = key.split('__');
      return {
        gun,
        slot_no: parseInt(slotNoRaw, 10),
        slot_etiketi: PROGRAM_OTURUMLARI.find(item => item.slot_no === parseInt(slotNoRaw, 10))?.slot_etiketi || `${slotNoRaw}. Oturum`,
        ders_id: cell.ders_id ? parseInt(cell.ders_id, 10) : null,
        konu: cell.konu?.trim() || '',
        soru_sayisi: cell.soru_sayisi ? parseInt(cell.soru_sayisi, 10) : null,
        aciklama: buildAciklama(cell.aciklama, cell.rehber_notu),
      };
    })
    .filter(item => item.ders_id);

  const doluHucreSayisi = olusturulanDetaylar.length;

  const handleProgramTuruSelect = (type) => {
    setForm(prev => ({
      ...prev,
      program_turu: type,
      bitis_tarihi: type === 'haftalik' ? addDaysToIso(prev.baslangic_tarihi, 6) : prev.baslangic_tarihi,
      baslik: prev.baslik || (type === 'haftalik' ? 'Haftalık Çalışma Programı' : 'Günlük Çalışma Programı'),
    }));
    setGridData({});
    setActiveCellKey(null);
  };

  const handleKaydet = async () => {
    if (!form.ogrenci_id) return toast.error('Önce öğrenci seçin');
    if (!form.program_turu) return toast.error('Program türü seçin');
    if (!form.baslangic_tarihi) return toast.error('Tarih seçin');
    if (form.program_turu === 'haftalik' && !form.bitis_tarihi) return toast.error('Bitiş tarihi oluşturulamadı');
    if (form.program_turu === 'haftalik' && form.bitis_tarihi < form.baslangic_tarihi) return toast.error('Bitiş tarihi başlangıçtan önce olamaz');
    if (olusturulanDetaylar.length === 0) return toast.error('En az bir hücreye ders ekleyin');

    const payload = {
      ogrenci_id: parseInt(form.ogrenci_id, 10),
      program_turu: form.program_turu,
      baslangic_tarihi: form.baslangic_tarihi,
      bitis_tarihi: form.program_turu === 'haftalik' ? form.bitis_tarihi : form.baslangic_tarihi,
      baslik: form.baslik?.trim() || (form.program_turu === 'haftalik' ? 'Haftalık Çalışma Programı' : 'Günlük Çalışma Programı'),
      hedef: form.hedef?.trim() || '',
      detaylar: olusturulanDetaylar,
    };

    setSaving(true);
    try {
      if (editingProgramId) {
        const { data } = await axios.put(`/rehberlik/programlar/${editingProgramId}`, payload);
        toast.success(data.message || 'Çalışma programı güncellendi');
      } else {
        const { data } = await axios.post('/rehberlik/programlar', payload);
        toast.success(data.message || 'Çalışma programı oluşturuldu');
      }
      resetBuilder();
      load();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Program kaydedilemedi');
    } finally {
      setSaving(false);
    }
  };

  const handleProgramDetay = async (id) => {
    setDetayLoading(true);
    try {
      const { data } = await axios.get(`/rehberlik/programlar/${id}`);
      if (data.success) setSeciliProgramDetay(data.data);
      else toast.error(data.message || 'Program detayı alınamadı');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Program detayı alınamadı');
    } finally {
      setDetayLoading(false);
    }
  };

  const handleProgramEdit = async (id) => {
    setDetayLoading(true);
    try {
      const { data } = await axios.get(`/rehberlik/programlar/${id}`);
      if (!data.success) {
        toast.error(data.message || 'Program detayı alınamadı');
        return;
      }
      const program = data.data;
      setEditingProgramId(id);
      setForm({
        ogrenci_id: String(program.ogrenci_id || ''),
        program_turu: program.program_turu || '',
        baslangic_tarihi: normalizeDateInput(program.baslangic_tarihi) || todayIso(),
        bitis_tarihi: normalizeDateInput(program.bitis_tarihi || program.baslangic_tarihi) || todayIso(),
        baslik: program.baslik || '',
        hedef: program.hedef || '',
      });
      setGridData(mapDetaylarToGrid(program.detaylar || []));
      setActiveCellKey(null);
      toast.success('Program düzenleme moduna alındı');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Program detayı alınamadı');
    } finally {
      setDetayLoading(false);
    }
  };

  const handleProgramDelete = async (id) => {
    if (!window.confirm('Bu programı silmek istediğinizden emin misiniz?')) return;
    try {
      const { data } = await axios.delete(`/rehberlik/programlar/${id}`);
      if (data?.success) {
        toast.success('Program silindi');
        if (editingProgramId === id) resetBuilder();
        if (seciliProgramDetay?.id === id) setSeciliProgramDetay(null);
        load();
      } else {
        toast.error(data?.message || 'Program silinemedi');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Program silinemedi');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <style>{`
        .program-summary-grid {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 12px;
        }
        .program-stat-card {
          background: linear-gradient(180deg, rgba(255,255,255,0.98), rgba(240,244,255,0.9));
          border: 1px solid var(--border);
          border-radius: 18px;
          padding: 16px;
          box-shadow: var(--shadow-card);
        }
        .program-builder-shell {
          display: grid;
          grid-template-columns: minmax(0, 1.55fr) minmax(320px, 0.95fr);
          gap: 18px;
          align-items: start;
        }
        .program-chooser-grid {
          display: grid;
          grid-template-columns: minmax(220px, 1.1fr) minmax(260px, 1fr);
          gap: 14px;
        }
        .program-type-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 10px;
        }
        .program-type-card {
          border: 1px solid var(--border);
          border-radius: 16px;
          padding: 14px;
          background: var(--bg-card);
          cursor: pointer;
          transition: all var(--dur-normal) var(--ease);
        }
        .program-type-card:hover {
          transform: translateY(-1px);
          border-color: var(--blue-border);
          box-shadow: var(--shadow-sm);
        }
        .program-type-card.active {
          border-color: var(--accent-border);
          background: linear-gradient(180deg, rgba(232,51,74,0.06), rgba(255,255,255,0.96));
          box-shadow: var(--shadow-red);
        }
        .program-table-wrap {
          overflow-x: auto;
          border: 1px solid var(--border);
          border-radius: 18px;
          background: var(--bg-card);
        }
        .program-table {
          width: 100%;
          min-width: 760px;
          border-collapse: collapse;
        }
        .program-table th,
        .program-table td {
          border-bottom: 1px solid var(--border);
          border-right: 1px solid var(--border);
          padding: 0;
          vertical-align: top;
          background: var(--bg-card);
        }
        .program-table th:last-child,
        .program-table td:last-child {
          border-right: none;
        }
        .program-table tr:last-child td {
          border-bottom: none;
        }
        .program-cell-button {
          width: 100%;
          min-height: 110px;
          background: transparent;
          border: none;
          text-align: left;
          padding: 12px;
          cursor: pointer;
          transition: background var(--dur-normal) var(--ease);
        }
        .program-cell-button:hover {
          background: var(--bg-card-hover);
        }
        .program-cell-button.active {
          background: rgba(37, 99, 235, 0.08);
          box-shadow: inset 0 0 0 2px rgba(37, 99, 235, 0.22);
        }
        .program-cell-button.filled {
          background: linear-gradient(180deg, rgba(16,185,129,0.09), rgba(255,255,255,0.96));
        }
        .program-side-card {
          position: sticky;
          top: 88px;
        }
        .program-detail-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: 12px;
        }
        .program-detail-row {
          padding: 12px;
          border-radius: 14px;
          background: var(--bg-elevated);
          border: 1px solid var(--border);
        }
        .program-card-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 16px;
        }
        @media (max-width: 1100px) {
          .program-summary-grid,
          .program-card-grid,
          .program-chooser-grid,
          .program-type-grid,
          .program-builder-shell {
            grid-template-columns: 1fr;
          }
          .program-side-card {
            position: static;
          }
        }
        @media (max-width: 900px) {
          .program-table {
            min-width: 100%;
          }
          .program-cell-button {
            min-height: 88px;
            padding: 10px;
          }
        }
      `}</style>

      <div className="section-header animate-fadeInUp" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>📋 Çalışma Programları</h2>
          <div className="section-subtitle">Öğrenci seç, program türünü belirle, tabloyu doldur ve kaydet.</div>
        </div>
        <button className="btn btn-outline" onClick={resetBuilder}>Formu Sıfırla</button>
      </div>

      <div className="program-summary-grid animate-fadeInUp stagger-1">
        <div className="program-stat-card">
          <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginBottom: 6 }}>Toplam Program</div>
          <div style={{ fontSize: '1.8rem', fontWeight: 800 }}>{programlar.length}</div>
        </div>
        <div className="program-stat-card">
          <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginBottom: 6 }}>Seçili Öğrenci</div>
          <div style={{ fontSize: '1rem', fontWeight: 700 }}>{seciliOgrenci ? `${seciliOgrenci.ad} ${seciliOgrenci.soyad}` : 'Henüz seçilmedi'}</div>
        </div>
        <div className="program-stat-card">
          <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginBottom: 6 }}>Program Türü</div>
          <div style={{ fontSize: '1rem', fontWeight: 700 }}>{form.program_turu === 'haftalik' ? 'Haftalık' : form.program_turu === 'gunluk' ? 'Günlük' : 'Henüz seçilmedi'}</div>
        </div>
        <div className="program-stat-card">
          <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginBottom: 6 }}>Dolu Hücre</div>
          <div style={{ fontSize: '1.8rem', fontWeight: 800 }}>{doluHucreSayisi}</div>
        </div>
      </div>

      <div className="card animate-fadeInUp stagger-2" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div className="program-chooser-grid">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div className="form-group">
              <label className="form-label">1. Öğrenci Seç *</label>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                <input
                  className="form-input"
                  placeholder="İsim veya numara ara"
                  value={ogrenciArama}
                  onChange={e => setOgrenciArama(e.target.value)}
                />
                <select
                  className="form-select"
                  value={ogrenciSinifFilter}
                  onChange={e => setOgrenciSinifFilter(e.target.value)}
                >
                  <option value="">Tüm Sınıflar</option>
                  {siniflar.map(sinif => (
                    <option key={sinif.id} value={sinif.id}>{sinif.ad}</option>
                  ))}
                </select>
              </div>
              <select
                className="form-select"
                value={form.ogrenci_id}
                onChange={e => setForm(prev => ({ ...prev, ogrenci_id: e.target.value }))}
              >
                <option value="">Öğrenci seçin</option>
                {filteredOgrenciler.map(ogr => (
                  <option key={ogr.id} value={ogr.id}>
                    {ogr.ad} {ogr.soyad}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Program Başlığı</label>
              <input
                className="form-input"
                value={form.baslik}
                onChange={e => setForm(prev => ({ ...prev, baslik: e.target.value }))}
                placeholder="TYT Haftalık Program"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Hedef</label>
              <textarea
                className="form-input"
                rows={3}
                value={form.hedef}
                onChange={e => setForm(prev => ({ ...prev, hedef: e.target.value }))}
                placeholder="Paragraf ve problem eksiğini kapat"
              />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div className="form-group">
              <label className="form-label">2. Program Türü *</label>
              <div className="program-type-grid">
                {PROGRAM_TURLERI.map(item => (
                  <button
                    key={item.value}
                    type="button"
                    className={`program-type-card ${form.program_turu === item.value ? 'active' : ''}`}
                    onClick={() => handleProgramTuruSelect(item.value)}
                  >
                    <div style={{ fontWeight: 800, fontSize: '0.92rem', marginBottom: 4 }}>{item.label}</div>
                    <div style={{ color: 'var(--text-muted)', fontSize: '0.78rem' }}>{item.helper}</div>
                  </button>
                ))}
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : (form.program_turu === 'haftalik' ? '1fr 1fr' : '1fr'), gap: 12 }}>
              <div className="form-group">
                <label className="form-label">{form.program_turu === 'gunluk' ? 'Program Tarihi *' : 'Başlangıç Tarihi *'}</label>
                <input
                  className="form-input"
                  type="date"
                  value={form.baslangic_tarihi}
                  onChange={e => {
                    const nextDate = e.target.value;
                    setForm(prev => ({
                      ...prev,
                      baslangic_tarihi: nextDate,
                      bitis_tarihi: prev.program_turu === 'haftalik' ? addDaysToIso(nextDate, 6) : nextDate,
                    }));
                    setGridData({});
                    setActiveCellKey(null);
                  }}
                />
              </div>
              {form.program_turu === 'haftalik' && (
                <div className="form-group">
                  <label className="form-label">Bitiş Tarihi</label>
                  <input className="form-input" type="date" value={form.bitis_tarihi} readOnly />
                </div>
              )}
            </div>

            <div style={{ padding: 14, borderRadius: 14, background: 'var(--bg-elevated)', color: 'var(--text-secondary)', fontSize: '0.82rem' }}>
              {form.program_turu === 'haftalik' ? (
                <span>Bu plan <strong>{formatDateLabel(form.baslangic_tarihi)}</strong> ile <strong>{formatDateLabel(form.bitis_tarihi)}</strong> arasını kapsar.</span>
              ) : (
                <span>Günlük plan <strong>{formatDateLabel(form.baslangic_tarihi)}</strong> tarihi için hazırlanır.</span>
              )}
            </div>
          </div>
        </div>

        {!form.ogrenci_id || !form.program_turu ? (
          <div className="empty-state" style={{ padding: '32px 16px', border: '1px dashed var(--border-strong)', borderRadius: 16 }}>
            <div style={{ fontSize: '2rem' }}>🧭</div>
            <h3>Önce akışı tamamlayın</h3>
            <p>Tabloyu açmak için öğrenci ve program türü seçimi zorunlu.</p>
          </div>
        ) : (
          <div className="program-builder-shell">
            <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
              <div style={{ padding: '16px 18px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
                <div>
                  <div style={{ fontWeight: 800, fontSize: '1rem' }}>
                    {form.program_turu === 'haftalik' ? 'Haftalık Program Tablosu' : 'Günlük Program Tablosu'}
                  </div>
                  <div style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>
                    Hücreye tıklayıp ders, konu, soru sayısı ve not alanlarını doldurun.
                  </div>
                </div>
                <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', alignSelf: 'center' }}>
                  {seciliOgrenci ? `${seciliOgrenci.ad} ${seciliOgrenci.soyad}` : ''}
                </div>
              </div>

              {isMobile && form.program_turu === 'haftalik' && gorunenGunler.length > 0 && (
                <div style={{ display: 'flex', gap: 8, padding: '10px 14px 0', overflowX: 'auto' }}>
                  {gorunenGunler.map(gun => (
                    <button
                      key={gun.key}
                      type="button"
                      className="btn btn-sm"
                      onClick={() => setMobilGun(gun.key)}
                      style={{
                        flex: '0 0 auto',
                        borderRadius: 999,
                        border: '1px solid var(--border)',
                        background: aktifMobilGun === gun.key ? 'var(--accent)' : 'var(--bg-elevated)',
                        color: aktifMobilGun === gun.key ? '#fff' : 'var(--text-secondary)',
                        fontWeight: 700,
                      }}
                    >
                      {gun.label}
                    </button>
                  ))}
                </div>
              )}

              <div className="program-table-wrap">
                <table className="program-table">
                  <thead>
                    <tr>
                      <th style={{ minWidth: 120, padding: '14px 12px', background: 'var(--bg-elevated)', fontSize: '0.78rem', textAlign: 'left' }}>Oturum</th>
                      {tabloGunler.map(gun => (
                        <th key={gun.key} style={{ minWidth: form.program_turu === 'haftalik' ? 170 : 260, padding: '14px 12px', background: 'var(--bg-elevated)', fontSize: '0.78rem', textAlign: 'left' }}>
                          <div style={{ fontWeight: 800 }}>{gun.label}</div>
                          {form.program_turu === 'gunluk' && (
                            <div style={{ fontWeight: 500, color: 'var(--text-muted)', marginTop: 2 }}>{formatDateLabel(form.baslangic_tarihi)}</div>
                          )}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {PROGRAM_OTURUMLARI.map(slot => (
                      <tr key={slot.slot_no}>
                        <td style={{ padding: '14px 12px', background: 'rgba(15,30,61,0.03)' }}>
                          <div style={{ fontWeight: 800, fontSize: '0.82rem' }}>{slot.slot_etiketi}</div>
                          <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>Günün çalışma bloğu</div>
                        </td>
                        {tabloGunler.map(gun => {
                          const key = getCellKey(gun.key, slot.slot_no);
                          const cell = normalizeCell(gridData[key]);
                          const ders = dersler.find(item => String(item.id) === String(cell.ders_id));
                          const filled = isCellMeaningful(cell);
                          return (
                            <td key={key}>
                              <button
                                type="button"
                                className={`program-cell-button ${activeCellKey === key ? 'active' : ''} ${filled ? 'filled' : ''}`}
                                onClick={() => setActiveCellKey(key)}
                              >
                                {filled ? (
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                                      <strong style={{ fontSize: '0.84rem' }}>{ders?.ad || 'Ders seçili'}</strong>
                                      {cell.soru_sayisi ? <span className="badge badge-success">{cell.soru_sayisi} soru</span> : null}
                                    </div>
                                    {cell.konu && <div style={{ fontSize: '0.78rem', color: 'var(--text-secondary)' }}>{cell.konu}</div>}
                                    {(cell.aciklama || cell.rehber_notu) && (
                                      <div style={{ fontSize: '0.74rem', color: 'var(--text-muted)' }}>
                                        {(cell.aciklama || cell.rehber_notu).slice(0, 70)}
                                        {(cell.aciklama || cell.rehber_notu).length > 70 ? '…' : ''}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <div style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>Ders ve çalışma bilgisi ekle</div>
                                )}
                              </button>
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card program-side-card" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <div style={{ fontWeight: 800, fontSize: '1rem' }}>Hücre Düzenleyici</div>
                <div style={{ color: 'var(--text-muted)', fontSize: '0.78rem', marginTop: 4 }}>
                  {activeCellMeta ? `${activeCellMeta.gunLabel} · ${activeCellMeta.slotEtiketi}` : 'Tablodan bir hücre seçin'}
                </div>
              </div>

              {activeCellMeta ? (
                <>
                  <div className="form-group">
                    <label className="form-label">Ders *</label>
                    <select
                      className="form-select"
                      value={activeCell.ders_id}
                      onChange={e => updateCellField('ders_id', e.target.value)}
                    >
                      <option value="">Ders seçin</option>
                      {dersler.map(ders => (
                        <option key={ders.id} value={ders.id}>{ders.ad}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Konu / Çalışma Açıklaması</label>
                    <input
                      className="form-input"
                      value={activeCell.konu}
                      onChange={e => updateCellField('konu', e.target.value)}
                      placeholder="Paragraf, problem, fonksiyonlar..."
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Soru Sayısı</label>
                    <input
                      className="form-input"
                      type="number"
                      min="0"
                      value={activeCell.soru_sayisi}
                      onChange={e => updateCellField('soru_sayisi', e.target.value)}
                      placeholder="40"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Çalışma Açıklaması</label>
                    <textarea
                      className="form-input"
                      rows={3}
                      value={activeCell.aciklama}
                      onChange={e => updateCellField('aciklama', e.target.value)}
                      placeholder="Yanlış soruları tekrar et, süre tut..."
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Rehber Öğretmen Notu</label>
                    <textarea
                      className="form-input"
                      rows={3}
                      value={activeCell.rehber_notu}
                      onChange={e => updateCellField('rehber_notu', e.target.value)}
                      placeholder="Motivasyon notu, dikkat edilmesi gerekenler..."
                    />
                  </div>

                  <div style={{ display: 'flex', gap: 10 }}>
                    <button className="btn btn-outline" style={{ flex: 1, justifyContent: 'center' }} onClick={clearActiveCell}>
                      Hücreyi Temizle
                    </button>
                    <button className="btn btn-primary" style={{ flex: 1, justifyContent: 'center' }} onClick={handleKaydet} disabled={saving}>
                      {saving ? 'Kaydediliyor...' : 'Programı Kaydet'}
                    </button>
                  </div>
                </>
              ) : (
                <div className="empty-state" style={{ padding: '20px 10px' }}>
                  <p>Detay girmek için tablodan bir hücre seçin.</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <div className="card animate-fadeInUp stagger-3" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: '1rem' }}>Oluşturulan Programlar</div>
            <div style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>Aynı ekranda mevcut programları görüntüleyin.</div>
          </div>
        </div>

        {loading ? (
          <div className="program-card-grid">
            {Array(4).fill(0).map((_, index) => <div key={index} className="skeleton" style={{ height: 170, borderRadius: 18 }} />)}
          </div>
        ) : programlar.length === 0 ? (
          <div className="empty-state" style={{ padding: '32px 12px' }}>
            <div style={{ fontSize: '2rem' }}>📚</div>
            <h3>Henüz program yok</h3>
            <p>İlk çalışma programını yukarıdaki tablo ile oluşturabilirsiniz.</p>
          </div>
        ) : (
          <div className="program-card-grid">
            {programlar.map(program => (
              <div key={program.id} className="card card-accent" style={{ padding: 18 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start', marginBottom: 12 }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: '0.96rem' }}>{program.baslik || 'Çalışma Programı'}</div>
                    <div style={{ color: 'var(--text-muted)', fontSize: '0.78rem', marginTop: 4 }}>
                      {program.ogrenci_ad} {program.ogrenci_soyad}
                    </div>
                  </div>
                  <span className={`badge ${program.program_turu === 'haftalik' ? 'badge-info' : 'badge-success'}`}>
                    {program.program_turu === 'haftalik' ? 'Haftalık' : 'Günlük'}
                  </span>
                </div>

                <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginBottom: 12 }}>
                  {formatDateLabel(program.baslangic_tarihi)}
                  {program.bitis_tarihi ? ` - ${formatDateLabel(program.bitis_tarihi)}` : ''}
                </div>

                {program.hedef && (
                  <div style={{ padding: '10px 12px', background: 'var(--bg-elevated)', borderRadius: 12, fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: 12 }}>
                    🎯 {program.hedef}
                  </div>
                )}

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
                  <div style={{ color: 'var(--text-muted)', fontSize: '0.78rem' }}>
                    {program.detay_sayisi || program.detaylar?.length || 0} oturum planlandı
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button className="btn btn-outline btn-sm" onClick={() => handleProgramDetay(program.id)} disabled={detayLoading}>
                      Detayı Gör
                    </button>
                    <button className="btn btn-outline btn-sm" onClick={() => handleProgramEdit(program.id)} disabled={detayLoading}>
                      Düzenle
                    </button>
                    <button className="btn btn-outline btn-sm" style={{ color: 'var(--danger)' }} onClick={() => handleProgramDelete(program.id)}>
                      Sil
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {seciliProgramDetay && (
        <div className="modal-backdrop" onClick={() => setSeciliProgramDetay(null)}>
          <div className="modal" style={{ maxWidth: 760 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">{seciliProgramDetay.baslik || 'Program Detayı'}</div>
              <button className="modal-close" onClick={() => setSeciliProgramDetay(null)}>✕</button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 12 }}>
                <div style={{ padding: 12, borderRadius: 12, background: 'var(--bg-elevated)' }}>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 4 }}>Öğrenci</div>
                  <div style={{ fontWeight: 700 }}>{seciliProgramDetay.ogrenci_ad} {seciliProgramDetay.ogrenci_soyad}</div>
                </div>
                <div style={{ padding: 12, borderRadius: 12, background: 'var(--bg-elevated)' }}>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 4 }}>Tarih Aralığı</div>
                  <div style={{ fontWeight: 700 }}>
                    {formatDateLabel(seciliProgramDetay.baslangic_tarihi)}
                    {seciliProgramDetay.bitis_tarihi ? ` - ${formatDateLabel(seciliProgramDetay.bitis_tarihi)}` : ''}
                  </div>
                </div>
              </div>

              {seciliProgramDetay.hedef && (
                <div style={{ padding: 14, borderRadius: 14, background: 'var(--accent-dim)', color: 'var(--accent)', fontSize: '0.84rem' }}>
                  🎯 {seciliProgramDetay.hedef}
                </div>
              )}

              <div>
                <div style={{ fontWeight: 800, fontSize: '0.92rem' }}>Program Detayları</div>
                <div className="program-detail-list">
                  {(seciliProgramDetay.detaylar || []).map(detay => (
                    <div key={`${detay.gun}-${detay.slot_no}-${detay.id || ''}`} className="program-detail-row">
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
                        <div style={{ fontWeight: 700 }}>{detay.gun} · {detay.slot_etiketi}</div>
                        <div style={{ color: 'var(--text-muted)', fontSize: '0.78rem' }}>{detay.soru_sayisi ? `${detay.soru_sayisi} soru` : 'Soru sayısı girilmedi'}</div>
                      </div>
                      <div style={{ marginTop: 6, color: 'var(--text-secondary)', fontSize: '0.84rem' }}>
                        <strong>{detay.ders_adi || detay.ders?.ad || 'Ders'}</strong>
                        {detay.konu ? ` · ${detay.konu}` : ''}
                      </div>
                      {detay.aciklama && (
                        <div style={{ marginTop: 8, color: 'var(--text-muted)', fontSize: '0.8rem', whiteSpace: 'pre-line' }}>
                          {detay.aciklama}
                        </div>
                      )}
                    </div>
                  ))}
                  {(seciliProgramDetay.detaylar || []).length === 0 && (
                    <div className="empty-state" style={{ padding: '18px 0' }}>
                      <p>Bu program için detay bulunamadı.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Etüt Talepleri ────────────────────────────────────────────
export function EtutlerPage() {
  const [talepler, setTalepler] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/rehberlik/etut-talepleri').then(res => {
      if (res.data.success) setTalepler(res.data.data || []);
    }).finally(() => setLoading(false));
  }, []);

  const handleDurumGuncelle = async (id, yeniDurum) => {
    try {
      await axios.put(`/rehberlik/etut-talepleri/${id}`, { durum: yeniDurum });
      setTalepler(prev => prev.map(t => t.id === id ? { ...t, durum: yeniDurum } : t));
      toast.success('Güncellendi!');
    } catch { toast.error('Hata'); }
  };

  const DURUM_COLORS = { bekliyor: 'var(--accent)', onaylandi: '#10B981', reddedildi: '#EF4444', tamamlandi: '#3B82F6' };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="animate-fadeInUp">
        <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>📚 Etüt Talepleri</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: 4 }}>Öğrencilerden gelen etüt talepleri</p>
      </div>

      {loading ? <div className="page-loader"><div className="spinner" /></div> :
        talepler.length === 0 ? (
          <div className="card"><div className="empty-state"><div style={{ fontSize: '2.5rem' }}>📚</div><h3>Etüt talebi yok</h3></div></div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }} className="animate-fadeInUp stagger-1">
            {talepler.map((t, i) => (
              <div key={i} className="card" style={{ borderLeft: `3px solid ${DURUM_COLORS[t.durum] || '#94A3B8'}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                    <div className="avatar avatar-sm" style={{ background: 'var(--accent-dim)', color: 'var(--accent)' }}>
                      {t.ogrenci_ad?.[0]}{t.ogrenci_soyad?.[0]}
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: '0.9rem' }}>{t.ogrenci_ad} {t.ogrenci_soyad}</div>
                      <div style={{ fontSize: '0.82rem', color: 'var(--text-secondary)', marginTop: 2 }}>
                        <strong>{t.ders_adi}</strong> — {t.konu || 'Genel etüt'}
                      </div>
                      {t.aciklama && <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 4 }}>{t.aciklama}</div>}
                      <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 4 }}>
                        {new Date(t.created_at).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
                    <span style={{
                      background: DURUM_COLORS[t.durum] + '20',
                      color: DURUM_COLORS[t.durum],
                      padding: '3px 10px', borderRadius: 99, fontSize: '0.75rem', fontWeight: 600,
                    }}>
                      {t.durum === 'bekliyor' ? '⏳ Bekliyor' : t.durum === 'onaylandi' ? '✅ Onaylandı' : t.durum === 'reddedildi' ? '❌ Reddedildi' : '✓ Tamamlandı'}
                    </span>
                    {t.durum === 'bekliyor' && (
                      <>
                        <button className="btn btn-success btn-sm" onClick={() => handleDurumGuncelle(t.id, 'onaylandi')}>Onayla</button>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDurumGuncelle(t.id, 'reddedildi')}>Reddet</button>
                      </>
                    )}
                    {t.durum === 'onaylandi' && (
                      <button className="btn btn-ghost btn-sm" onClick={() => handleDurumGuncelle(t.id, 'tamamlandi')}>Tamamlandı</button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      }
    </div>
  );
}

// ── Randevu Yönetimi (Paylaşımlı) ────────────────────────────
export function RandevularPage({ mod = 'rehber' }) {
  const [randevular, setRandevular] = useState([]);
  const [ogretmenler, setOgretmenler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [planModal, setPlanModal] = useState({ open: false, randevuId: null, tarih: '', saat: '', sure_dakika: 30 });
  const [form, setForm] = useState({
    ogretmen_id: '', tarih: '', saat: '', sure_dakika: 30, konu: '', notlar: '',
  });

  const saatNormalize = (val = '') => String(val).slice(0, 5);

  const apiErrorToast = (err, fallback = 'İşlem sırasında hata oluştu') => {
    const status = err?.response?.status;
    const message = err?.response?.data?.message || err?.response?.data?.error || fallback;

    if (status === 400) {
      toast.error(`Geçersiz veri/saat: ${message}`);
      return;
    }
    if (status === 409) {
      toast.error(`Seçilen saat dolu veya çakışıyor: ${message}`);
      return;
    }
    toast.error(message);
  };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const rRes = await axios.get('/randevular').catch(() => ({ data: { success: false, data: [] } }));
      const oRes = (mod === 'ogrenci' || mod === 'veli')
        ? await axios.get('/ogretmenler-listesi').catch(() => ({ data: { success: false, data: [] } }))
        : { data: { success: false, data: [] } };
      if (rRes.data.success) setRandevular(rRes.data.data || []);
      if (oRes.data.success) {
        setOgretmenler(
          (oRes.data.data || []).map((o, i) => ({
            ...o,
            full_name: `${o.ad || ''} ${o.soyad || ''}`.trim(),
            _randevu_target_id: o.ogretmen_id ?? o.user_id ?? o.og_id ?? o.id ?? i,
          }))
        );
      }
    } catch (e) {
      console.error('Randevular load error:', e.message);
    }
    finally { setLoading(false); }
  }, [mod]);

  useEffect(() => { load(); }, [load]);

  const handleCreate = async () => {
    if (mod === 'ogrenci' && !form.ogretmen_id) {
      toast.error('Öğretmen/Rehber seçimi zorunlu');
      return;
    }

    if (!form.konu) {
      toast.error('Konu zorunlu');
      return;
    }

    try {
      const seciliOgretmen = ogretmenler.find((o) => String(o._randevu_target_id) === String(form.ogretmen_id));
      const targetId = seciliOgretmen?._randevu_target_id ?? form.ogretmen_id;

      const payload = mod === 'ogrenci'
        ? {
            ogretmen_id: Number(targetId),
            konu: form.konu,
            notlar: form.notlar || undefined,
          }
        : {
            ogretmen_id: form.ogretmen_id ? Number(targetId) : undefined,
            tarih: form.tarih,
            saat: form.saat,
            sure_dakika: Number(form.sure_dakika),
            konu: form.konu,
          };
      await axios.post('/randevular', payload);
      toast.success('Randevu talebi gönderildi!');
      setShowModal(false);
      setForm({ ogretmen_id: '', tarih: '', saat: '', sure_dakika: 30, konu: '', notlar: '' });
      load();
    } catch (err) {
      apiErrorToast(err, 'Randevu oluşturulamadı');
    }
  };

  const handleDurumGuncelle = async (id, durum) => {
    try {
      await axios.put(`/randevular/${id}`, { durum });
      toast.success('Randevu güncellendi!');
      load();
    } catch (err) { toast.error(err?.response?.data?.message || 'Hata'); }
  };

  const openPlanlaOnayModal = (r) => {
    setPlanModal({
      open: true,
      randevuId: r.id,
      tarih: r.tarih ? String(r.tarih).slice(0, 10) : '',
      saat: r.saat ? String(r.saat).slice(0, 5) : '',
      sure_dakika: Number(r.sure_dakika) || 30,
    });
  };

  const handlePlanlaVeOnayla = async () => {
    if (!planModal.randevuId) return;
    if (!planModal.tarih || !planModal.saat || !planModal.sure_dakika) {
      toast.error('Tarih, saat ve süre zorunlu');
      return;
    }

    try {
      await axios.put(`/randevular/${planModal.randevuId}`, {
        durum: 'onaylandi',
        tarih: planModal.tarih,
        saat: planModal.saat,
        sure_dakika: Number(planModal.sure_dakika),
      });
      toast.success('Randevu planlanıp onaylandı');
      setPlanModal({ open: false, randevuId: null, tarih: '', saat: '', sure_dakika: 30 });
      load();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Onaylama hatası');
    }
  };

  const DURUM_COLORS = { bekliyor: 'var(--accent)', onaylandi: '#10B981', reddedildi: '#EF4444', tamamlandi: '#3B82F6', iptal: '#94A3B8' };
  const DURUM_ICONS = { bekliyor: '⏳', onaylandi: '✅', reddedildi: '❌', tamamlandi: '✓', iptal: '⊘' };
  const DURUM_LABELS = { bekliyor: 'Bekliyor', onaylandi: 'Onaylandı', reddedildi: 'Reddedildi', iptal: 'İptal', tamamlandi: 'Tamamlandı' };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="section-header animate-fadeInUp">
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>📆 Randevular</h2>
          <div className="section-subtitle">{randevular.length} randevu</div>
        </div>
        {(mod === 'veli' || mod === 'ogrenci') && (
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Randevu Al</button>
        )}
      </div>

      {loading ? <div className="page-loader"><div className="spinner" /></div> :
        randevular.length === 0 ? (
          <div className="card"><div className="empty-state"><div style={{ fontSize: '2.5rem' }}>📆</div><h3>Randevu yok</h3><p>Henüz randevu oluşturulmamış.</p></div></div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }} className="animate-fadeInUp stagger-1">
            {randevular.map((r, i) => (
              <div key={i} className="card" style={{ borderLeft: `3px solid ${DURUM_COLORS[r.durum] || '#94A3B8'}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                      <span style={{ fontSize: '1.1rem' }}>{DURUM_ICONS[r.durum]}</span>
                      <span style={{ fontWeight: 700 }}>{r.talep_eden_adi} → {r.ogretmen_adi || 'Öğretmen'}</span>
                    </div>
                    <div style={{ fontSize: '0.82rem', color: 'var(--text-secondary)' }}>
                      {r.tarih ? `📅 ${new Date(r.tarih).toLocaleDateString('tr-TR')}` : '📅 Tarih öğretmen tarafından belirlenecek'}
                      {r.saat ? ` · ⏰ ${r.saat}` : ''}
                    </div>
                    {r.konu && <div style={{ fontSize: '0.82rem', marginTop: 6 }}>Konu: {r.konu}</div>}
                    {r.notlar && <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 4 }}>{r.notlar}</div>}
                  </div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
                    <span style={{
                      background: DURUM_COLORS[r.durum] + '20',
                      color: DURUM_COLORS[r.durum],
                      padding: '4px 12px', borderRadius: 99, fontSize: '0.78rem', fontWeight: 600,
                    }}>
                      {DURUM_LABELS[r.durum] || r.durum}
                    </span>
                    {(mod === 'rehber' || mod === 'ogretmen') && r.durum === 'bekliyor' && (
                      <>
                        <button className="btn btn-success btn-sm" onClick={() => openPlanlaOnayModal(r)}>Onayla</button>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDurumGuncelle(r.id, 'reddedildi')}>Reddet</button>
                      </>
                    )}
                    {r.durum === 'onaylandi' && (mod === 'rehber' || mod === 'ogretmen') && (
                      <button className="btn btn-ghost btn-sm" onClick={() => handleDurumGuncelle(r.id, 'tamamlandi')}>Tamamlandı</button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      }

      {showModal && (
        <div className="modal-backdrop" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">📆 Randevu Al</div>
              <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div className="form-group">
                <label className="form-label">Öğretmen / Rehber *</label>
                <select
                  className="form-select"
                  value={form.ogretmen_id}
                  onChange={(e) => setForm({ ...form, ogretmen_id: e.target.value, tarih: '', saat: '' })}
                >
                  <option value="">Seçin</option>
                  {ogretmenler.map((o, i) => (
                    <option key={o._randevu_target_id || i} value={o._randevu_target_id}>
                      {o.ad} {o.soyad}{o.rol ? ` (${o.rol === 'rehber_ogretmen' ? 'Rehber' : 'Öğretmen'})` : ''}
                    </option>
                  ))}
                </select>
              </div>
              {mod !== 'ogrenci' && (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
                  <div className="form-group">
                    <label className="form-label">Tarih *</label>
                    <input
                      className="form-input"
                      type="date"
                      value={form.tarih}
                      onChange={(e) => setForm({ ...form, tarih: e.target.value, saat: '' })}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Süre (dk) *</label>
                    <select
                      className="form-select"
                      value={form.sure_dakika}
                      onChange={(e) => setForm({ ...form, sure_dakika: Number(e.target.value), saat: '' })}
                    >
                      {[15, 30, 45, 60].map((d) => <option key={d} value={d}>{d} dk</option>)}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Saat *</label>
                    <input className="form-input" type="time" value={form.saat} onChange={e => setForm({ ...form, saat: saatNormalize(e.target.value) })} />
                  </div>
                </div>
              )}
              {mod === 'ogrenci' && (
                <div style={{ padding: '10px 12px', border: '1px dashed var(--border)', borderRadius: 12, fontSize: '0.82rem', color: 'var(--text-muted)' }}>
                  Bu ekranda sadece görüşme talebi oluşturursun. Gün ve saat seçimini öğretmen/rehber onay aşamasında belirler.
                </div>
              )}
              <div className="form-group">
                <label className="form-label">Konu *</label>
                <input className="form-input" placeholder="Görüşme konusu" value={form.konu} onChange={e => setForm({ ...form, konu: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">Notlar</label>
                <textarea className="form-textarea" placeholder="Ek bilgi..." value={form.notlar} onChange={e => setForm({ ...form, notlar: e.target.value })} style={{ minHeight: 70 }} />
              </div>
              <div style={{ display: 'flex', gap: 10 }}>
                <button className="btn btn-primary" style={{ flex: 1, justifyContent: 'center' }} onClick={handleCreate}>✓ Talep Gönder</button>
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {planModal.open && (
        <div className="modal-backdrop" onClick={() => setPlanModal({ open: false, randevuId: null, tarih: '', saat: '', sure_dakika: 30 })}>
          <div className="modal" style={{ maxWidth: 520 }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">🗓️ Randevu Planla ve Onayla</div>
              <button className="modal-close" onClick={() => setPlanModal({ open: false, randevuId: null, tarih: '', saat: '', sure_dakika: 30 })}>✕</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div className="form-group">
                <label className="form-label">Tarih *</label>
                <input className="form-input" type="date" value={planModal.tarih} onChange={(e) => setPlanModal((p) => ({ ...p, tarih: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Saat *</label>
                <input className="form-input" type="time" value={planModal.saat} onChange={(e) => setPlanModal((p) => ({ ...p, saat: String(e.target.value).slice(0, 5) }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Süre (dk) *</label>
                <select className="form-select" value={planModal.sure_dakika} onChange={(e) => setPlanModal((p) => ({ ...p, sure_dakika: Number(e.target.value) }))}>
                  {[15, 30, 45, 60].map((d) => <option key={d} value={d}>{d} dk</option>)}
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button className="btn btn-success" style={{ flex: 1, justifyContent: 'center' }} onClick={handlePlanlaVeOnayla}>Onayla</button>
              <button className="btn btn-secondary" onClick={() => setPlanModal({ open: false, randevuId: null, tarih: '', saat: '', sure_dakika: 30 })}>İptal</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
